import classNames from 'classnames'
import { memo } from 'preact/compat'

type BannerEventInfoProps = {
    dateAndTime: string
    boutiqueLocation: string
    languages: string
    desktop?: boolean
}

const BannerEventInfo = ({
    dateAndTime,
    boutiqueLocation,
    languages,
    desktop
}: BannerEventInfoProps) => (
    <>
        {(dateAndTime || boutiqueLocation || languages) && (
            <div
                className={classNames('fs-banner__event-info', {
                    'fs-banner__event-info--desktop': Boolean(desktop)
                })}>
                {dateAndTime && <p>{dateAndTime}</p>}
                {boutiqueLocation && <p>{boutiqueLocation}</p>}
                {languages && <p>{languages}</p>}
            </div>
        )}
    </>
)

export default memo(BannerEventInfo)
